var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockIconAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M16.043 21H1.958A1.951 1.951 0 010 19.056V8.946a1.95 1.95 0 011.958-1.944h.377V6.62h.012C2.348 2.964 5.333 0 9.015 0a6.618 6.618 0 016.635 6.622c0 .134.006.258.006.38h.386A1.95 1.95 0 0118 8.946v10.11A1.95 1.95 0 0116.043 21zM9.028 2.334c-2.379 0-4.307 1.916-4.308 4.278h-.008v.39h8.605V6.97c.011-.113.02-.23.02-.358 0-2.363-1.93-4.279-4.309-4.279zm6.634 7.788a.78.78 0 00-.783-.778H3.123a.78.78 0 00-.783.778v7.77c0 .43.35.779.783.779h11.756a.78.78 0 00.784-.778v-7.771z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIconAlt);
export default __webpack_public_path__ + "static/media/lock-icon-alt.b4acec751f36798799e1da76fff2d4b2.svg";
export { ForwardRef as ReactComponent };